import { render, staticRenderFns } from "./CampaignPointsPage.vue?vue&type=template&id=38630c8a&"
import script from "./CampaignPointsPage.vue?vue&type=script&lang=js&"
export * from "./CampaignPointsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports